import { z } from "zod";

/** Search da lista de produtos. Valor inválido na URL vira undefined em vez de quebrar a rota. */
export const productsSearch = z.object({
  q: z.string().trim().max(100).optional().catch(undefined),
  status: z.enum(["active", "inactive"]).optional().catch(undefined),
  kind: z.enum(["P", "S"]).optional().catch(undefined),
  format: z.enum(["S", "V", "E"]).optional().catch(undefined),
  includeVariations: z.enum(["yes", "no"]).optional().catch(undefined),
  hasImage: z.enum(["yes", "no"]).optional().catch(undefined),
  hasNcm: z.enum(["yes", "no"]).optional().catch(undefined),
  /** "recent" = Últimos incluídos. */
  sort: z.enum(["name", "recent"]).optional().catch(undefined),
});
export type ProductsSearch = z.output<typeof productsSearch>;
